import { ListboxOption, Listbox, ListboxButton, ListboxOptions, Checkbox, Field, Label, Dialog, DialogPanel, DialogTitle, DialogBackdrop, Combobox, ComboboxInput, ComboboxButton, ComboboxOptions, ComboboxOption, Switch, Radio, RadioGroup, } from "@headlessui/react";
export const HeadlessUi = {
    ListboxOption,
    Listbox,
    ListboxButton,
    ListboxOptions,
    Combobox,
    ComboboxButton,
    ComboboxInput,
    ComboboxOptions,
    ComboboxOption,
    Checkbox,
    Field,
    Label,
    Dialog,
    DialogPanel,
    DialogTitle,
    DialogBackdrop,
    Switch,
    Radio,
    RadioGroup,
};
//# sourceMappingURL=headlessUi.js.map